"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ThemeProvider;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _lodash = _interopRequireDefault(require("lodash"));
var _styles = require("../../styles");
var _FontLinks = _interopRequireDefault(require("../FontLinks"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ThemeProvider({
  themeOverride,
  children,
  cleanBackground,
  globalStyle,
  noFontImport
}) {
  return /*#__PURE__*/_react.default.createElement(_styledComponents.ThemeProvider, {
    theme: _lodash.default.merge(_styles.theme, themeOverride)
  }, !noFontImport && /*#__PURE__*/_react.default.createElement("head", null, /*#__PURE__*/_react.default.createElement(_FontLinks.default, null)), /*#__PURE__*/_react.default.createElement(_styles.GlobalStyle, {
    cleanBackground: cleanBackground,
    globalStyle: globalStyle
  }), children);
}